export default {
	layout: "tennis",
	sets: 3,
	winnerPoints: 6,
	deuce: true,
	pointsShown: [15, 30, 40],
	doesntHaveTime: true,
	// isIndividualSport: true,
}
